<template>
  <section class="feature-section">
    <div class="container">
      <div class="my-5 pb-1 px-2">
        <h2 class="section-title">À qui s’adresse Livratos&nbsp;?</h2>
        <p class="section-subtitle">
          Une plateforme pensée pour connecter <strong>fournisseurs</strong>,
          <strong>livreurs</strong> et <strong>artisans du bâtiment</strong>.
        </p>
      </div>

      <div class="row justify-content-center">
        <div
          class="col-12 mb-4 col-md-6 col-lg-4 d-flex justify-content-center"
        >
          <router-link :to="{ name: 'Fournisseur' }" class="card-link">
            <article class="card">
              <div class="card-img">
                <div class="card-imgs bg-stock"></div>
              </div>
              <div class="project-info">
                <div class="flex">
                  <h3 class="project-title">Fournisseurs</h3>
                  <span class="tag">BTP</span>
                </div>
                <p class="lighter">
                  Proposez un <strong>service de livraison</strong> fiable à vos
                  clients sans gérer votre propre flotte de véhicules ni la
                  <strong>logistique du dernier kilomètre</strong>.
                </p>
              </div>
            </article>
          </router-link>
        </div>

        <div
          class="col-12 mb-4 col-md-6 col-lg-4 d-flex justify-content-center"
        >
          <router-link :to="{ name: 'Livrateur' }" class="card-link">
            <article class="card">
              <div class="card-img">
                <div class="card-imgs bg-livraison"></div>
              </div>
              <div class="project-info">
                <div class="flex">
                  <h3 class="project-title">Livreurs</h3>
                  <span class="tag">INDÉ</span>
                </div>
                <p class="lighter">
                  <strong>Recevez des missions</strong> BTP adaptées à votre
                  véhicule, avec des clients professionnels et un cadre de
                  travail clair et sécurisé.
                </p>
              </div>
            </article>
          </router-link>
        </div>

        <div
          class="col-12 mb-4 col-md-6 col-lg-4 d-flex justify-content-center"
        >
          <router-link :to="{ name: 'Artisans' }" class="card-link">
            <article class="card">
              <div class="card-img">
                <div class="card-imgs bg-eco"></div>
              </div>
              <div class="project-info">
                <div class="flex">
                  <h3 class="project-title">Artisans</h3>
                  <span class="tag">BTP</span>
                </div>
                <p class="lighter">
                  <strong
                    >Faites livrer vos matériaux directement sur
                    chantier</strong
                  >
                  et évitez d’immobiliser vos équipes pour
                  <strong>aller chercher du matériel en urgence</strong>.
                </p>
              </div>
            </article>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup></script>

<style lang="scss" scoped>
.feature-section {
  background-color: $background;
  padding-top: 100px;
  padding-bottom: 80px;

  .section-title {
    font-size: 1.8rem;
    font-weight: 700;
    color: $color-text;

    @media (min-width: 768px) {
      font-size: 2.5rem;
    }

    @media (min-width: 1200px) {
      font-size: 2.75rem;
    }
  }

  .section-subtitle {
    font-size: 1rem;
    color: $color-text-grey;
    margin-top: 0.5rem;
    margin-bottom: 3rem;

    @media (min-width: 768px) {
      font-size: 1.125rem;
      margin-bottom: 4rem;
    }
  }

  .row {
    gap: 2rem 0;
  }

  .card-link {
    text-decoration: none;
    color: inherit;
    display: block;
  }

  .card {
    background-color: black;
    color: black;
    width: 100%;
    max-width: 380px;
    cursor: pointer;

    @media (min-width: 992px) {
      max-width: 300px;
    }

    height: 100%;
    border-radius: 8px;
    border: 0.5px solid $color-primary;
    box-shadow: rgba(50, 50, 93, 0.2) 0px 30px 60px -10px,
      rgba(0, 0, 0, 0.15) 0px 18px 36px -18px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
      transform: translateY(-8px);
      box-shadow: rgba(50, 50, 93, 0.25) 0px 35px 70px -12px,
        rgba(0, 0, 0, 0.2) 0px 20px 40px -20px;
    }

    @media (min-width: 992px) {
      margin-bottom: 0;
    }

    .card-img {
      position: relative;
      top: -20px;
      height: 100px;
      display: flex;
      justify-content: center;

      .card-imgs {
        height: 150px;
        width: 70%;
        border-radius: 8px;
        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
        transition: all 0.5s;
        background-color: $color-primary;
        background-repeat: no-repeat;
        background-position: center bottom;
        background-size: contain;
      }

      .bg-livraison {
        background-image: url("@/assets/icons/icon-livreur.webp");
      }

      .bg-stock {
        background-image: url("@/assets/icons/icon-fournisseur.webp");
      }

      .bg-eco {
        background-image: url("@/assets/icons/icon-artisan.webp");
      }
    }

    .project-info {
      padding: 100px 30px 40px;
      display: flex;
      flex-direction: column;
      gap: 15px;
      position: relative;
      top: -50px;

      .flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .project-title {
        font-weight: 600;
        font-size: 1.25rem;
        color: $background;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .tag {
        font-size: 0.9rem;
        font-weight: 400;
        color: $color-primary;
      }

      .lighter {
        font-size: 0.95rem;
        color: $color-lighter;
      }
    }
  }
}
</style>
